import React, {Component} from 'react';
import { Spin, message } from 'antd';
import {delResource, loadInterviewResource, otherFileConvertParams} from "../../actions/interview";
import TaskUpload from "../../view/components/taskUpload/taskUpload";
import ChunkUpload from "../upload/ChunkUpload";
import UploadWall from "../upload/UploadWall";
import {checkFileStatus} from "../../actions/upload";
import {Scrollbars} from "react-custom-scrollbars";
import {ATTCHMENT_TYPE, PIC_TYPE} from "../../constants/index";

class NewsActivityArtFile extends Component {

    

    render() {
        return (
            <div style={{ padding: 15, background: '#f4f6fc' }}>
                <TaskUpload
                    fileType={4}
                    icons={["download", "delete"]}
                    taskId={this.props.data.id}
                    data={this.props.data}
                />
            </div>
        );
    }
}

export default NewsActivityArtFile;